import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import i18n from './i18n'
import Layout from './components/Layout.vue';

Vue.use(ElementUI);

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(Layout)
});
